import type { ThemeType } from "@pandas/core-ui";
import { ReactNode } from "react";
import { X } from "tabler-icons-react";
import Button from "../Buttons/Button";

interface PopupProps {
	theme?: ThemeType;
	show: boolean;
	closeButton?: () => void;
	setShow?: (value: boolean) => void;
	content: ReactNode;
	primaryButtonLabel?: string | ReactNode;
	secondaryButtonLabel?: string | ReactNode | null;
	primaryButtonOnClick?: () => void;
	secondaryButtonOnClick?: () => void;
}

export default function Popup({
	theme,
	show,
	setShow,
	closeButton,
	content,
	primaryButtonLabel,
	primaryButtonOnClick,
	secondaryButtonLabel,
	secondaryButtonOnClick,
}: PopupProps) {
	const hasSecondaryButton = secondaryButtonOnClick && secondaryButtonLabel;
	const hasPrimaryButton = primaryButtonOnClick && primaryButtonLabel;
	return (
		<>
			{show && (
				<div
					className={`h-[100dvh] w-full bg-black bg-opacity-${
						theme === "dark" ? "90" : "30"
					} flex justify-center items-center fixed top-0 left-0 !m-0 z-50 text-black`}
					onClick={() => {
						setShow && setShow(false);
					}}
				>
					<div
						className="bg-white rounded-lg min-w-[50%] max-w-[90%] max-h-[90%] w-fit sm:min-h-[20rem] h-fit flex flex-col justify-center items-center text-center whitespace-pre-line pt-6 px-6 sm:px-12 pb-6 sm:pb-12 relative"
						onClick={(e) => e.stopPropagation()}
					>
						{closeButton && (
							<X
								onClick={closeButton}
								className="absolute top-4 right-4"
							/>
						)}
						{content}
						{(hasPrimaryButton || hasSecondaryButton) && (
							<div className="flex mt-4 sm:mt-14 justify-center items-center flex-col-reverse sm:flex-row sm:flex-wrap gap-2 w-full">
								{hasSecondaryButton && (
									<Button
										intent="secondary"
										size="small"
										label={secondaryButtonLabel}
										onClick={secondaryButtonOnClick}
									/>
								)}
								{hasPrimaryButton && (
									<Button
										size="small"
										label={primaryButtonLabel}
										onClick={primaryButtonOnClick}
									/>
								)}
							</div>
						)}
					</div>
				</div>
			)}
		</>
	);
}
